import config from 'utils/apiconfig';
import request from 'utils/request';

const { api } = config;
const { role, roleId, permission } = api;

/**
 * 角色列表
 */
export async function roleList(params) {
  return request({ url: role, method: 'get', data: params, });
}
/**
 * 创建列表
 */
export async function createItem(params) {
  return request({ url: role, method: 'post', data: params, });
}
/**
 * 权限列表
 */
export async function permissionList() {
  return request({ url: permission, method: 'get' });
}
/**
 * 角色列表
 */
export async function deleteItem(params) {
  return request({ url: role + '/delete', method: 'post', data: params, });
}
/**
 * 编辑角色列表
 */
export async function edit(params) {
  return request({ url: roleId, method: 'put', data: params, });
}
/**
 * 查询角色详情
 */
export async function getDetail(paramId) {
  return request({
    url: roleId, method: 'get', data: {
      id: paramId
    },
  });
}
